<template>
    <div class="biometrics-edit mb-3 mt-page">

        <data-form
                   :title="$i18n.gt('LABEL_EDIT_BIOMETRICS')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="biometricsFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_BIOMETRICS_UPDATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_BIOMETRICS')"
                   :submit-success-route="`/biometrics/practiceId/${practiceId}`"
                   :cancel-route="`/biometrics/practiceId/${practiceId}`">
        </data-form>

    </div>
</template>

<script>

    import Vue from 'vue'
    import * as _ from 'lodash'
    import BiometricsFields from '../models/Biometrics'

    /**
     * Page for practitioner to edit a Biometrics record
     */
    export default Vue.extend({
        name: 'BiometricsEdit',
        props: {
            practiceId: Number,
            biometricsId: Number
        },
        data () {
            return {
                biometricsFields: BiometricsFields,
                fieldGroups: [
                    ['participant_id', 'external_id', 'comment'],
                    ['tchol', 'ldl_c', 'hdl_c', 'trig', 'fasting_bg', 'a1c'],
                ]
            }
        },
        methods: {
            loadModelInstance () {
                return this.$api.getItem(this, 'biometrics', this.biometricsId, ['participant'])
            },
            onSubmit (modelInstance) {
                return this.$api.updateItem(this, 'biometrics', modelInstance)
            },
        }
    })

</script>
